export default class Precisions {
	[key: string]: any;
	isSuiteCureThermale: boolean;
	isEnRapportAvecAffectionPensionneGuerre: boolean;
	isEnRapportAvecDecesEnfant: boolean;
	dateDecesEnfant: string;
	isSuiteAccidentTiers: boolean;
	dateAccidentTiers: string;
	isAutoriseActivites: boolean;
	dateAutoriseActivites: string;

	constructor(
		isSuiteCureThermale = false,
		isEnRapportAvecAffectionPensionneGuerre = false,
		isEnRapportAvecDecesEnfant = false,
		dateDecesEnfant = '',
		isSuiteAccidentTiers = false,
		dateAccidentTiers = '',
		isAutoriseActivites = false,
		dateAutoriseActivites = ''
	) {
		this.isSuiteCureThermale = isSuiteCureThermale;
		this.isEnRapportAvecAffectionPensionneGuerre = isEnRapportAvecAffectionPensionneGuerre;
		this.isEnRapportAvecDecesEnfant = isEnRapportAvecDecesEnfant;
		this.dateDecesEnfant = dateDecesEnfant;
		this.isSuiteAccidentTiers = isSuiteAccidentTiers;
		this.dateAccidentTiers = dateAccidentTiers;
		this.isAutoriseActivites = isAutoriseActivites;
		this.dateAutoriseActivites = dateAutoriseActivites;
	}
}
